import { FaPencilAlt } from 'react-icons/fa'

import { Avatar } from '../../../../../components/Avatar'
import { Button } from '../../../../../components/Button'
import { usePermission } from '../../../../../hooks/usePermission'
import { cn } from '../../../../../libs/tailwindMerge'
import { Store } from '../../../../../services/storesServices'

interface TableStoresRowProps {
  store: Store
  onEdit: (store: Store) => void
  onEditStoreGroup: (storeGroupId: string) => void
}

export function StoresTableRow({ store, onEdit, onEditStoreGroup }: TableStoresRowProps) {
  const { updateStore, updateStorePromoters, upsertStoreGroup, isObserver } = usePermission()

  return (
    <tr
      className="border-t border-slate-500 hover:bg-white_transparency hover:bg-opacity-15"
    >
      <td
        scope="row"
        className="font-medium whitespace-nowrap sticky left-0 border-r border-slate-500 w-12"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="rounded-md overflow-hidden p-2">
              <Avatar className="w-10 h-10 rounded-md border border-gray-300" imageUrl={store.group.logo_url} />
            </div>
            <span>{store.group.name}</span>
          </div>
          {upsertStoreGroup && !isObserver && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onEditStoreGroup(store.group.id)}
              title="Editar Grupo"
            >
              <FaPencilAlt />
            </Button>
          )}
        </div>
      </td>
      <td
        scope="row"
        className="font-medium whitespace-nowrap sticky left-0 border-r border-slate-500 w-12 pl-2"
      >
        <span>{store.name}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2"
      >
        <span>{store.city} - {store.state}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        <span className={cn(
          !store.seller && store.sellers_list.length === 0 && 'text-gray-400 font-thin',
        )}
        >
          {store.sellers_list.length > 0 || store.seller
            ? (
              <>
                {store.seller && store.seller.name}
                {store.sellers_list.length > 0 && store.sellers_list.map((item, index) => (
                  <div key={index}>
                    {item.seller.name} <br />
                  </div>
                ))}
              </>
              )
            : (
              <>
                Sem vendedor
              </>
              )}
        </span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        <span className={cn(
          !store.supervisor && 'text-gray-400 font-thin',
        )}
        >{store.supervisor
          ? store.supervisor.name
          : 'Sem supervisor'}
        </span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 p-2 text-center"
      >
        <div className="flex flex-row space-x-2 justify-end">
          <Button
            size="icon"
            title="Editar usuário"
            disabled={!(updateStore || updateStorePromoters) || isObserver}
            onClick={() => onEdit(store)}
            className="disabled:bg-slate-400 hover:disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            <FaPencilAlt />
          </Button>
        </div>
      </td>
    </tr>
  )
}
